export default {
    HIDE_AREA: "HIDE_AREA",
    SET_LOGIN_CONTENT: "SET_LOGIN_CONTENT",
    SET_PAGES: "SET_PAGES",
    SET_PAGE_DATA: "SET_PAGE_DATA",
    SET_PAGE_RESOURCES: "SET_PAGE_RESOURCES",
    SET_NEW_PAGE: "SET_NEW_PAGE",
    ADD_PAGE_TO_NAV: "ADD_PAGE_TO_NAV",
    SET_SITE_ERROR: "SET_SITE_ERROR",
    SET_ARTICLES: "SET_ARTICLES",
    ADD_NEW_ARTICLE: "ADD_NEW_ARTICLE",
    SET_ARTICLE_DATA: "SET_ARTICLE_DATA",
    UPDATE_RESOURCE: "UPDATE_RESOURCE",
    REMOVE_PAGE: "REMOVE_PAGE",
    REMOVE_ARTICLE: "REMOVE_ARTICLE",
    DELETE_RESOURCE: "DELETE_RESOURCE",
}
